import { useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import { ModuleDashboardPage } from '../../../shared/components/index.js';
import { fetchExecutivesDashboard } from '../services/executivesService.js';

const SECTIONS = [
  {
    id: 'ranking',
    chartKey: 'ranking',
    title: 'Ranking de ejecutivos',
    note: 'Diseñado para score compuesto (no solo volumen bruto).'
  },
  { id: 'leads', chartKey: 'leads', title: 'Leads por ejecutivo' },
  { id: 'conversion', chartKey: 'conversion', title: 'Conversión por ejecutivo' },
  { id: 'actividad', chartKey: 'actividad', title: 'Actividad comercial' },
  { id: 'respuesta', chartKey: 'respuesta', title: 'Tiempo de respuesta' },
  { id: 'seguimiento', chartKey: 'seguimiento', title: 'Cumplimiento de seguimientos' },
  { id: 'reservasVentas', chartKey: 'reservasVentas', title: 'Reservas y ventas por ejecutivo' },
  { id: 'tabla', type: 'table', title: 'Desempeño' }
];

export default function EjecutivosPage() {
  const { email } = useOutletContext() || {};
  const loadData = useCallback((f) => fetchExecutivesDashboard(f), []);
  return (
    <ModuleDashboardPage
      title="Ejecutivos"
      subtitle="Productividad del equipo comercial (contacto, reunión, reserva, velocidad)."
      email={email}
      loadData={loadData}
      filterOpts={{ showProject: true, showExecutive: true }}
      sections={SECTIONS}
    />
  );
}
